/**
 *
 * list state selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';

const selectList = (state) =>  state.list;

const makeSelectListItems = () =>
    createSelector(
        selectList,
        (listState) => _get(listState,'data.items')
    );

export {
    selectList,
    makeSelectListItems
};
